export default __webpack_public_path__ + "9a672c9c0777601955c2730695387cbe.png";